import { r as registerInstance, f as forceUpdate, h, H as Host } from './index-5aea3fea.js';
import { i as i18nProvider, l as loadTranslations } from './loadTranslations-f63b1e5d.js';

const CreateServiceCaseModal = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.handleModalClose = () => {
            window.location.reload();
        };
        this.fileUpload = false;
        this.prefillData = null;
        this.modalName = undefined;
        this.locale = "en-US";
        this.env = "prod";
        this.legacyApi = false;
        this.submitted = false;
    }
    handleServiceCaseSuccess() {
        this.modal.triggerClose();
    }
    handleServiceCaseCancel() {
        this.modal.triggerClose();
    }
    connectedCallback() {
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
        this.onLocaleChange();
    }
    disconnectedCallback() {
        i18nProvider.unsubscribe(this.i18nSubscriberId);
    }
    onLocaleChange() {
        if (this.locale !== i18nProvider.language) {
            this.loadTranslations();
        }
    }
    handleServiceCaseShowSuccess() {
        this.submitted = true;
    }
    loadTranslations() {
        loadTranslations(this.locale).then((locale) => {
            i18nProvider.changeLanguage(locale);
            this.locale = locale;
        });
    }
    render() {
        const t = (key, options = undefined) => i18nProvider.t(`mf-service-calls:${String(key)}`, options);
        return (h(Host, { key: '5211776658ac81b845e530ac7177811460f03695' }, h("ux-modal", { key: '2cf0157974f9d77da69c71d6a8b7a8160899882c', onUxModalClose: () => this.handleModalClose(), name: this.modalName, ref: (el) => (this.modal = el) }, h("ux-modal-content", { key: '1c7b9f3e99fbeb6b3db6343cd7de5db81fe5568f' }, h("mf-create-service-case", { key: '78574d9446ec55652321ee0b723b4dcd27853e92', fileUpload: this.fileUpload, prefillData: this.prefillData, multipleSteps: true, locale: this.locale, env: this.env, legacyApi: this.legacyApi }, h("slot", { key: '22c62f6a243db11bc9b38170a7f636d49d69ac3b', name: "connector" }))), this.submitted && (h("ux-modal-footer", { key: '31ea34adf04c773cf2e2ab03b459928d7c5d606e' }, h("ux-button", { key: 'bc8602f67548bf5630095f9fa78b3e3dd7850ce8', variant: "primary", onClick: () => {
                this.modal.triggerClose();
            } }, t("button.ok")))))));
    }
    static get watchers() { return {
        "locale": ["onLocaleChange"]
    }; }
};

export { CreateServiceCaseModal as mf_create_service_case_modal };

//# sourceMappingURL=mf-create-service-case-modal.entry.js.map